import { api } from "./client";

// --- Типове ---

// Успешен отговор от POST /cleanup/zero-total-bills
export interface CleanupZeroTotalBillsResponse {
  deleted_bills_count: number;   // Колко сметки бяха изтрити
  deleted_reports: number;       // Колко отчета бяха изтрити (защото всичките им сметки са махнати)
  recalculated_reports: number;  // Колко отчета бяха преизчислени (имаха и други сметки)
  remaining_bills: number;       // Колко сметки останаха в базата
  // MAX(bills.id) СЛЕД цялата операция. Номерата се ПРЕНАРЕЖДАТ на 1..N без
  // дупки, така че при успех това е и броят оцелели сметки. Пренареждането
  // върви само след като всяка каса е зачистила регистъра си — иначе стар
  // фискален бон увисва под номера на нова сметка.
  // Виж docs/cleanup-zero-total-bills.md.
  new_max_bill_id: number;
  // По един ред на каса (FiscalAPI инсталация), зачистена като част от
  // операцията. Празен масив = нямаше какво да се оптимизира и касите не
  // бяха пипнати.
  tills?: CleanupTillResult[];
  message?: string;              // Опционално съобщение (напр. "Няма сметки за изтриване")
}

// Отчетът на една каса за зачистването си.
export interface CleanupTillResult {
  client_name: string;
  status: string;
  deleted_total?: number;  // Колко реда паднаха там общо
  backup?: string;         // Името на резервното копие, направено преди триенето
}

// --- API функции ---

/**
 * POST /cleanup/zero-total-bills
 * Почиства сметки без касова бележка (с нулева обща сума).
 * Не приема тяло, параметри или query string — само Authorization header.
 * Операцията може да отнеме няколко секунди при много сметки.
 */
export async function cleanupZeroTotalBills(): Promise<CleanupZeroTotalBillsResponse> {
  const response = await api.post<CleanupZeroTotalBillsResponse>(
    "/cleanup/zero-total-bills"
  );
  return response.data;
}
